( function ( $ ) {
	const testimonialsSlider = function ( $block ) {
		const $slider = $block.find( '.testimonials-slider__slider' );

		if ( ! $slider.length ) {
			return;
		}

		$slider.not( '.slick-initialized' ).slick( {
			infinite: true,
			dots: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			rows: 0,
			prevArrow: $block.find( '.testimonials-slider__arrow--prev' ),
			nextArrow: $block.find( '.testimonials-slider__arrow--next' ),
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		} );
	};

	// Initialize each block on page load (front end).
	$( function () {
		$( '.testimonials-slider' ).each( function () {
			testimonialsSlider( $( this ) );
		} );
	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=testimonials-slider',
			testimonialsSlider
		);
	}
} )( jQuery );
